import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { getAlertHighlight, getCompanyAlerts } from './thunk'

const initialState = {
  alertHighlight: {},
  companyAlerts: {
    data: [],
    dataById: {},
  },

  loading: {
    alertHighlight: true,
    companyAlerts: true,
  },
}

const slice = createSlice({
  name: 'portfolio/summary/alerts',
  initialState,
  reducers: {
    resetStore: () => initialState,
  },
  extraReducers: (builder) => {
    //getAlertHighlight
    builder.addCase(getAlertHighlight.pending, (state) => {
      state.loading.alertHighlight = true
    })
    builder.addCase(getAlertHighlight.fulfilled, (state, { payload = {} }) => {
      state.alertHighlight = payload
      state.loading.alertHighlight = false
    })
    builder.addCase(getAlertHighlight.rejected, (state, action) => {
      state.loading.alertHighlight = action.payload.loading
    })
    //getCompanyAlerts
    builder.addCase(getCompanyAlerts.pending, (state) => {
      state.loading.companyAlerts = true
    })
    builder.addCase(getCompanyAlerts.fulfilled, (state, action) => {
      state.companyAlerts.data = action.payload
      state.companyAlerts.dataById = keyBy(action.payload, 'recordId')
      state.loading.companyAlerts = false
    })
    builder.addCase(getCompanyAlerts.rejected, (state, action) => {
      state.loading.companyAlerts = action.payload.loading
    })
  },
})

export const selectAlertHighlight = (callback) => (state) => {
  const data = state[slice.name].alertHighlight
  return callback ? callback(data) : data
}
export const selectCompanyAlerts = (callback) => (state) => {
  const data = state[slice.name].companyAlerts.data
  return callback ? callback(data) : data
}
export const selectCompanyAlertsById = (id, attr) => (state) => {
  const dataById = state[slice.name].companyAlerts.dataById
  if (!id) return dataById
  if (!attr) return dataById[id]
  return dataById[id][attr]
}

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return loadingObj[type]
}

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
